
import { PropType, defineComponent } from 'vue';
import { MoovDropInput, MoovDropInputProperties } from '@/interfaces/moov';

export default defineComponent({
  name: 'MoovInputWrapper',

  props: {
    label: { type: String, required: true },
    invalidMsg: { type: String, default: '' },
    inputProperties: {
      type: Object as PropType<Partial<MoovDropInputProperties>>,
      default: () => ({})
    },
  },

  data: () => ({
    error: '',
    isDirty: false,
  }),

  async mounted() {
    await this.$nextTick();

    const input = this.$el.querySelector('.input > *') as MoovDropInput;

    Object.assign(input, this.inputProperties);

    input.onChange = () => {
      this.error = !input.validity.valid ? this.invalidMsg || input.validationMessage : '';
      this.$emit('change');
    };

    input.onInput = () => {
      this.error = '';
    };

    input.onFocus = () => {
      this.isDirty = true;
    };
  }
});
